import { FaTag } from "react-icons/fa6";
import { SlHome } from "react-icons/sl";
import {
  MdWorkOutline,
  MdWork,
  MdOutlineContactPage,
  MdOutlineStarBorderPurple500,
  MdOutlineAutoGraph,
  MdContactPage,
  MdStar
} from "react-icons/md";
import { IoMagnet, IoMagnetOutline } from "react-icons/io5";
import { FiTag } from "react-icons/fi";

export const translationDefaults = {
  component: "webapp",
  version: "0.1",
  language: "en-US"
};

export const menuItems: { [name: string]: string } = {
  home: "Home",
  companies: "Companies",
  people: "People",
  leads: "Leads",
  deals: "Deals",
  contracts: "Contracts",
  upsells: "Upsells"
};

export const pageNames: { [name: string]: string } = {
  searchResults: "Search Results"
};

export const icons: { [name: string]: JSX.Element } = {
  home: <SlHome />,
  companies: <MdWorkOutline />,
  companiesFilled: <MdWork />,
  people: <MdOutlineContactPage />,
  peopleFilled: <MdContactPage />,
  leads: <IoMagnetOutline />,
  leadsFilled: <IoMagnet />,
  deals: <MdOutlineStarBorderPurple500 />,
  dealsFilled: <MdStar />,
  contracts: <FiTag />,
  contractsFilled: <FaTag />,
  upsells: <MdOutlineAutoGraph />
};

export const SETTINGS_REFERRER_KEY = "settingsReferrer";
